import { AttachmentsUploaderContextProvider } from '@components'

import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { useMemo } from 'react'

import { ZervantLocale } from '../../../invoices/enums/zervantLocale'
import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import { SendAsEmailModalVariant } from '../../enums/sendAsEmailModalVariant'
import { SendAsEmailForm } from '../../types/sendAsEmailForm'
import { getUploadAttachmentSessionUrl } from '../../utils/getUploadAttachmentSessionUrl'
import { SendAsEmailFormContextProvider } from './contexts/sendAsEmailFormContext'
import { SendAsEmailModalContextProvider } from './contexts/sendAsEmailModalContext'
import { SendAsEmailModalComponent } from './elements/SendAsEmailModalComponent'
import { SendAsEmailModalView } from './types/sendAsEmailModalView'

interface SendAsEmailProps extends ModalProps {
  contactId?: string | undefined
  documentLocale?: ZervantLocale
  documentType: InvoiceDocumentType
  invoiceNumber: string
  isSubmitting: boolean
  onSubmit: (formData: SendAsEmailForm) => void
  variant: SendAsEmailModalVariant
  view: SendAsEmailModalView
}

const SendAsEmail = ({
  contactId,
  documentLocale,
  documentType,
  invoiceNumber,
  isSubmitting,
  onSubmit,
  variant = SendAsEmailModalVariant.Invoice,
  view,
  ...modalProps
}: SendAsEmailProps) => {
  const { sessionId, url: uploadAttachmentUrl } = useMemo(() => getUploadAttachmentSessionUrl(), [])

  return (
    <SendAsEmailModalContextProvider
      contactId={contactId}
      documentLocale={documentLocale}
      documentType={documentType}
      invoiceNumber={invoiceNumber}
      view={view}
    >
      <AttachmentsUploaderContextProvider sessionId={sessionId} url={uploadAttachmentUrl}>
        <SendAsEmailFormContextProvider isSubmitting={isSubmitting} onSubmit={onSubmit} variant={variant}>
          <SendAsEmailModalComponent {...modalProps} />
        </SendAsEmailFormContextProvider>
      </AttachmentsUploaderContextProvider>
    </SendAsEmailModalContextProvider>
  )
}

export const SendAsEmailModal = withModalConditionalRender(SendAsEmail)
